import { Observable, of } from "rxjs";
import { UsersSearchForm } from "../types/users-search-form.interface";
import { mapUsersSearchFormToQueryParameters } from "../types/users-search-form.functions";
import { switchMap } from "rxjs/operators";
import { IUser } from "../../../types/user/iuser.interface";
import * as http from "../../../services/http.service";
import { SearchResults } from "../../../types/search/search-results.interface";

export function searchUsers(searchForm: UsersSearchForm): Observable<IUser[]> {
  return doSearch(mapUsersSearchFormToQueryParameters(searchForm));
}

export function fetchAllUsers(): Observable<IUser[]> {
  return doSearch();
}

function doSearch(query = ""): Observable<IUser[]> {
  return http.get<SearchResults<IUser>>(endPoint(query)).pipe(
    switchMap((response) => {
      return fetchNextPageAndAddToResponse(response);
    })
  );
}

function endPoint(query = ""): string {
  if (query.indexOf("?q=") > -1) {
    return `/search/users-simplified/${query}`;
  }

  return `/search/users/${query}`;
}

const fetchNextPageAndAddToResponse = (
  response: SearchResults<IUser>,
  users: IUser[] = []
): Observable<IUser[]> => {
  const allUsers = users.concat(response.results);

  if (response.next) {
    return getNextPage(response.next).pipe(
      switchMap((next) => {
        return fetchNextPageAndAddToResponse(next, allUsers);
      })
    );
  }

  return of(allUsers);
};

function getNextPage(urlForNextPage: string): Observable<SearchResults<IUser>> {
  return http.get<SearchResults<IUser>>(endPoint(queryForNextPage(urlForNextPage)));
}

function queryForNextPage(urlForNextPage: string): string {
  return `?page=${urlForNextPage.split("?page=")[1]}`;
}
